export default __webpack_public_path__ + "static/media/hht2_ep02_timeline_q01_a.e165fba8.png";